module.exports = __webpack_public_path__ + "static/media/invoice.38e23f33.svg";